<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_REPORT_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Báo cáo danh sách thiết bị xuất nhập tồn</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <b-form-group id="example-month">
              <b-form-input
                v-model="valueMonthYear"
                min="2010-01"
                :max="maxMonth"
                id="month"
                type="month"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Loại báo cáo"
              :options="listType"
              v-model="search.type"
              @change="getRegionByType($event)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Vùng kinh doanh" :options="listRegion" v-model="search.regionId">
            </Select2>
          </div>
          <div class="form-group">
            <button
              @click="submitForm"
              class="mr-2 btn btn-primary hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Lọc
            </button>
            <button
              @click="removeForm"
              class="mr-2 btn btn-outline-light hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataReport"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(type)="data">
                {{ data.item.type | transformData(listType) }}
              </template>
              <template #cell(month)="data">
                {{ data.item.month | transformData(listMonth) }}
              </template>
              <template #cell(action)="data">
                <span
                  type="button"
                  class="text-primary"
                  v-if="dataPermission.includes('CNPS_DEVICE_REPORT_DOWNLOAD')"
                  @click="download(data.item.id)"
                  ><i class="bx bx-download"></i> Tải xuống</span
                >
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config.js'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'

  const fieldsTable = [
    { key: 'index', label: 'STT' },
    { key: 'month', label: 'Tháng' },
    { key: 'year', label: 'Năm' },
    { key: 'type', label: 'Loại' },
    { key: 'regionName', label: 'Vùng' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        loading: false,
        valueMonthYear: '',
        listRegion: [],
        listType: Config.typeDiviceReport,
        search: {
          limit: 20,
          page: 1,
          type: 'ALL',
        },
        pagination: {
          total: 0,
        },
        dataReport: [],
        listMonth: Config.monthConfig,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        fieldsTable,
        filterTable: fieldsTable,
      }
    },
    computed: {
      maxMonth: function () {
        return `${new Date().getFullYear()}-${new Date().getMonth() + 1}`
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    created() {
      this.fetchData()
    },
    mixins: [prepareQueryParamsMixin],
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      getMonthName(monthNumber) {
        const date = new Date()
        date.setMonth(monthNumber - 1)

        return date.toLocaleString('en-US', { month: 'short' }).toUpperCase()
      },
      async getRegions() {
        const dataRes = await StaffService.getListRegions()
        if (dataRes.data.length > 0) {
          this.listRegion = dataRes.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
        }
      },
      async getRegionByType(e) {
        if (e === 'REGION') {
          await this.getRegions()
        } else {
          this.listRegion = []
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          type: 'ALL',
        }
        this.valueMonthYear = ''
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          if (this.valueMonthYear !== '') {
            this.search.year = Number(this.valueMonthYear.substring(0, 4))
            this.search.month = this.getMonthName(
              this.valueMonthYear.substring(
                this.valueMonthYear.length - 2,
                this.valueMonthYear.length
              )
            )
          }
          const data = await DeviceService.listReport(this.search)
          if (data.success) {
            this.pagination.total = data.data.count
            this.dataReport = data.data.reports
          } else {
            this.errorModal(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async download(id) {
        try {
          this.loading = true
          await DeviceService.downloadReport({
            id: id,
          })
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      successModal(msg) {
        this.notiModal = true
        this.msgNoti = msg
        this.iconNoti = require('@/assets/img/noti-success2.svg')
      },
      errorModal(msg) {
        this.notiModal = true
        this.msgNoti = msg
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      },
    },
  }
</script>
